<template>
  <div class="uk-background-muted">
    <nav
      id="mainNavbar"
      class="uk-navbar-container"
      style="background-color: black"
      uk-navbar
    >
      <a
        class="uk-margin-left uk-margin-top logo uk-text-left"
        href="https://contrak.us"
        target="_blank"
        style="color: white"
      >
        contrak
      </a>
      <h2
        class="uk-margin-left uk-margin-top uk-text-left"
        style="color: white"
      >
        |
      </h2>
      <h2
        class="uk-margin-left uk-margin-top uk-text-left"
        style="color: white"
      >
        Customer Portal
      </h2>
    </nav>
    <div class="uk-container uk-container-xlarge">
      <!-- <ApolloQuery :query="orderQuery" :variables="variables"> -->
      <!-- <template v-slot="{ result: { error, data }, isLoading }"> -->
      <!-- Loading -->
      <div v-if="isLoading" class="loading apollo">Loading...</div>

      <!-- Error -->
      <div v-else-if="error" class="error apollo">
        Could not find that order. Whoops.
      </div>

      <!-- Result -->
      <div v-else-if="order" class="result apollo uk-text-left">
        <h1 class="uk-margin-top">{{ order.company.name }} | Order Status</h1>
        <Button
          class="uk-margin-bottom"
          :href="generateHashForBillingCustomer(order.billTo.id)"
        >
          View all orders
        </Button>
        <OrderDetailHeader :showAvailabilityButton="false" :order="order">
        </OrderDetailHeader>
        <p class="uk-margin-small-top">
          <b>Order Status:</b>
          <!-- Trip Status -->

          <span v-if="!order.status" class="uk-label uk-label-warning"
            >Unknown</span
          >
          <span
            v-else-if="order.status == 'Complete'"
            class="uk-label uk-label-orange"
            >Complete</span
          >
          <span
            v-else-if="order.status === 'In Progress'"
            class="uk-label uk-label-success"
          >
            {{ order.status }}
          </span>
          <span v-else-if="order.status === 'Not Available'" class="uk-label uk-label-danger"
            >Not Available</span
          >
          <span v-else-if="order.status === 'Cancelled'" class="uk-label uk-label-danger"
            >Cancelled</span
          >

          <span v-else class="uk-label">{{ order.status }}</span>
          <!-- Availability -->
        </p>
        <div class="uk-width-1-1">
          <div class="uk-margin-small-left uk-flex uk-grid uk-width-1-1">
            <TerminalAddressCard
              class="uk-width-1-3"
              :isExportOrder="isExportOrder"
              :order="order"
            ></TerminalAddressCard>
            <ReceiverAddressCard
              :order="order"
              class="uk-width-1-3"
              :editable="false"
              :showDetails="false"
              :showEditContact="false"
            >
            </ReceiverAddressCard>
            <div class="uk-width-1-3">
              <BillToAddressCard
                :billingContact="order.billingContact"
                :orderId="order.id"
                :billTo="order.billTo"
                :editable="false"
                :showDetails="false"
                :showEditContact="false"
              ></BillToAddressCard>
            </div>
          </div>
        </div>
        <div
          class="uk-card-small uk-card-default uk-card-body uk-margin-top uk-margin-bottom"
        >
          <table
            class="uk-table uk-table-striped uk-table-middle uk-table-small uk-table-divider"
          >
            <thead>
              <tr>
                <th>Ship Line</th>
                <th v-if="isExportOrder">Booking number</th>
                <th v-else-if="order.billOfLading">Bill Of Lading</th>
                <th>Vessel Name</th>
                <th>{{ !isExportOrder ? 'Vessel ETA' : 'Vessel Cutoff' }}</th>
                <th>Carrier Reference #</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{ order.shipLine }}
                </td>
                <td v-if="order.billOfLading">
                  {{ order.billOfLading.billOfLadingId }}
                </td>
                <td v-else-if="isExportOrder">
                  {{ order.bookingNumber }}
                </td>
                <td>
                  {{ order.vesselName }}
                </td>
                <td>
                  {{ order.vesselEtaString }}
                </td>
                <td>
                  <div class="uk-margin-top">
                    <p> {{ order.referenceNumber }}</p>
                  </div>
                </td>
                <td>
                  <p> {{ order.billingReferenceNumber }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <OrderContainerTable
          :showDriver="false"
          :editable="false"
          :order="order"
          :containersWithTrips="containersWithTrips"
        ></OrderContainerTable>

        <VesselFinderEmbed v-if="order.vessel" class="uk-margin-top" :mssi="order.vessel.mssi"> </VesselFinderEmbed>
      </div>

      <!-- No result -->
      <div v-else class="no-result apollo">No result :(</div>
      <!-- </template> -->
      <!-- </ApolloQuery> -->
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import Button from '@/components/core/Button.vue';

import OrderQuery from '@/gql/orders/queries/OrderStatus.gql';

import VesselFinderEmbed from '@/components/ContainerTracker/Vessel/VesselFinderEmbed.vue';
import OrderDetailHeader from '../OrderDetail/OrderDetailHeader.vue';
import BillToAddressCard from '../AddressCards/BillToAddressCard.vue';
import TerminalAddressCard from '../AddressCards/TerminalAddressCard.vue';
import ReceiverAddressCard from '../AddressCards/ReceiverAddressCard.vue';
import OrderContainerTable from '../OrderDetail/OrderContainersTable.vue';

export default defineComponent({
  data() {
    return {
      orderQuery: OrderQuery,

      error: undefined,
    };
  },
  components: {
    OrderDetailHeader,
    BillToAddressCard,
    TerminalAddressCard,
    ReceiverAddressCard,
    OrderContainerTable,
    Button,
    VesselFinderEmbed,
  },
  methods: {
    generateHashForBillingCustomer(id) {
      return `/status/orders/${btoa(id)}`;
    },
  },
  computed: {
    isLoading(): boolean {
      const vm = (this as any);
      return vm.$apollo.queries.order.loading;
    },
    orderId(): string | undefined {
      const vm = (this as any);

      if (vm.$route.params.hash) {
        return atob(vm.$route.params.hash);
      }

      return undefined;
    },
    isExportOrder(): boolean {
      const vm = (this as any);

      if (!vm.order) {
        return false;
      }
      return vm.order.isExport;
    },
    containersWithTrips(): any[] {
      const vm = (this as any);

      if (!vm.order) {
        return [];
      }
      const trips = vm.order.trips;
      const tripContainers = [];
      for (
        let index = 0;
        index < vm.order.containers.length;
        index += 1
      ) {
        const container = vm.order.containers[index];
        container.trips = [];
        trips.forEach((trip) => {
          if (trip.container.id === container.id) {
            container.trips.push(trip);
          }
        });

        container.trips = container.trips.sort((a, b) => {
          return Number(a.legId) < Number(b.legId) ? -1 : 1;
        });

        tripContainers.push(container);
      }

      if (vm.order.isExport) {
        return tripContainers.sort((a, b) => a.id.localeCompare(b.id));
      } else {
        return tripContainers.sort((a, b) =>
          a.containerId.localeCompare(b.containerId),
        );
      }
    },
  },
  ...{
    apollo: {
      order: {
        query: OrderQuery,
        variables() {
          return { id: (this as any).orderId };
        },
        skip() {
          const vm = (this as any);

          return !vm || !vm.$route || !vm.orderId;
        },
        pollInterval: 30000,
        error(err) {
          const vm = (this as any);

          console.error(err);
          if (err.graphQLErrors.length > 0) {
            vm.error = err.graphQLErrors[0].message;
          } else {
            vm.error = err.networkError.message;
          }
        },
      },
    },
    // },
  },
});
</script>